export const setShippingMethodsOnCartCommand = {
    execute: async (context, shippingMethodParams, customQuery, customHeaders) => {
        var _a, _b;
        const { data } = await context.app.$vsf.$magento.api.setShippingMethodsOnCart(shippingMethodParams, customQuery, customHeaders);
        // TODO: Find out why 'Cart' doesn't match the type of the response data.
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.setShippingMethodsOnCart) === null || _a === void 0 ? void 0 : _a.cart) !== null && _b !== void 0 ? _b : null;
    },
};
